import React, { createContext, useEffect, useReducer, useState } from "react";
import { reducer } from "./MenuContextReducers";
import { apiCall } from "../_services/apiCall";
import config from "../config/config.json";

const initialState = {
  menus: JSON.parse(localStorage.getItem("menu")) || [],
  role: localStorage.getItem("role"),
};

export const PermissionMenuContext = createContext({
  ...initialState,
  userPermissionList: [],
  userCapabilities: [],
});

export default function PermissionBasedMenuProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [userPermissionList, setUserPermissionList] = useState([]);
  const [userCapabilities, setUserCapabilities] = useState([]);

  // Compute and sync userPermissionList dynamically whenever state.menus changes
  useEffect(() => {
    const permissionsArray = [];
    const menus = state?.menus || [];
    menus.forEach((item) => {
      if (item.permissions) {
        item.permissions.forEach((perm) => {
          if (perm) {
            if (typeof perm === 'string') {
              permissionsArray.push(perm);
            } else if (perm.permissionCode) {
              permissionsArray.push(perm.permissionCode);
              permissionsArray.push(perm);
            }
          }
        });
      }
      if (item.sub_menu) {
        item.sub_menu.forEach((subItem) => {
          if (subItem.permissions) {
            subItem.permissions.forEach((perm) => {
              if (perm) {
                if (typeof perm === 'string') {
                  permissionsArray.push(perm);
                } else if (perm.permissionCode) {
                  permissionsArray.push(perm.permissionCode);
                  permissionsArray.push(perm);
                }
              }
            });
          }
        });
      }
    });
    setUserPermissionList(permissionsArray);
  }, [state?.menus]);

  // Synchronize context state with localStorage dynamically (cross-tab via event, same-tab via polling)
  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedMenu = localStorage.getItem("menu");
        const parsedMenu = storedMenu ? JSON.parse(storedMenu) : [];
        if (JSON.stringify(parsedMenu) !== JSON.stringify(state.menus)) {
          dispatch({ type: "Add_Menu", payload: parsedMenu });
        }
      } catch (e) {
        console.error("Error parsing menu from localStorage:", e);
      }

      const storedRole = localStorage.getItem("role");
      if (storedRole !== state.role) {
        dispatch({ type: "Add_Role", payload: storedRole });
      }
    };

    // Listen to storage events (cross-tab sync)
    window.addEventListener("storage", handleStorageChange);

    // Poll to sync same-tab updates immediately
    const intervalId = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, [state.menus, state.role]);

  // Fetch capabilities dynamically when active role changes
  useEffect(() => {
    const fetchCapabilities = async () => {
      try {
        const res = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}authorization/user/capabilities`,
          {},
          {},
          "GET",
          false,
          false
        );
        if (res?.isSuccess && Array.isArray(res.data)) {
          setUserCapabilities(res.data);
        } else if (Array.isArray(res)) {
          setUserCapabilities(res);
        }
      } catch (e) {
        console.error("Error fetching user capabilities:", e);
      }
    };

    if (localStorage.getItem("token")) {
      fetchCapabilities();
    } else {
      setUserCapabilities([]);
    }
  }, [state.role]);

  return (
    <PermissionMenuContext.Provider value={{ state, dispatch, userPermissionList, userCapabilities }}>
      {children}
    </PermissionMenuContext.Provider>
  );
}


